import Form2 from "../Commen/Form2"

const Contact = () => {
    return (
        <>
            <div id="contact" className="Contact position-relative overflow-hidden p-3 p-md-3 text-center">
                <div className="col-md-10 border shadow py-5 px-3 mx-auto my-5 fw-bold">
                    <h2 className="display-5 fw-bolder mb-4 text-center text-danger Contact-title"
                        data-aos="fade-down">Don’t be Shy, Say Hello!</h2>
                    <h3 className="text-primary text-center px-5 contact-text"
                        data-aos="fade-up"
                        data-aos-delay="200">WE’LL GUIDE YOU, WORK WITH YOU AND DELIVER THE BEST</h3>
                    <Form2 />
                </div>
                <div className="product-device shadow-sm d-none d-md-block"></div>
                <div className="product-device product-device-2 shadow-sm d-none d-md-block"></div>
            </div>
        </>
    )
}

export default Contact